exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ql-container .ql-editor {\n  min-height: 200px;\n  padding-bottom: 1rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/ngx-quill-editor/quillEditor.component.css
// module id = ../../../../ngx-quill-editor/quillEditor.component.css
// module chunks = common